import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Components
import { Button } from '@pella/sash-framework';

// Styles
import styles from './index.module.scss';

const CalendarDay = ({ innerText, onClick, selected, id, empty, hasTimeslots, arrayStartPosition, timeslotLength, disabled }) => (
	// const [client, setClient] = useState(false);

	// useEffect(() => {
	// 	setClient(true);
	// }, []);

	<div className={styles.rtaCalendar_Day_Data}>
		{empty ? (
			<Button
				color='secondary'
				type='button'
				aria-label={innerText ? innerText : 'Unavailable Day'}
				disabled
			>
				{innerText ? innerText : ''}
			</Button>
		) : (
			<Button
				className={!hasTimeslots ? '' : selected ? styles.rtaCalendar_Day_Selected : styles.rtaCalendar_Day_Available}
				color='secondary'
				type='button'
				disabled={disabled ? true : hasTimeslots ? false : true}
				onClick={() => {
					onClick(id, arrayStartPosition, timeslotLength);
				}}
				aria-label={innerText ? innerText : 'Unavailable Day'}
			>
				{innerText ? innerText : ''}
			</Button>
		)}
	</div>
);
CalendarDay.propTypes = {
	innerText: PropTypes.number,
	onClick: PropTypes.func.isRequired,
	selected: PropTypes.bool,
	id: PropTypes.any,
	empty: PropTypes.bool,
	hasTimeslots: PropTypes.bool,
	arrayStartPosition: PropTypes.number,
	timeslotLength: PropTypes.number,
	disabled: PropTypes.bool,
};

export default CalendarDay;
